import React from 'react';
import { useParams } from 'react-router-dom';
import { ScoreRoundForm, ScoreRoundFormProps } from './ScoreRoundForm';
import { useScoreRoundAuthed } from './useScoreRoundByCode';

interface Props extends Omit<ScoreRoundFormProps, 'data'> {
    apiPath: string;
}

/**
 * Scoring form page for grid arbitrators.
 * If the page api path and slug are provided, the round info and the scoring controls will be plugged
 * in place of the `info` and `scores` components, respectively.
 * Otherwise info and scores will be returned, wrapped in a FormWrapper.
 * @param props 
 * @returns 
 */
export const ScoreRoundAuthedContainer = (props: Props) => {
    const { id } = useParams<{ id: string }>();
    const data = useScoreRoundAuthed(props.apiPath, { round_id: id });

    return <ScoreRoundForm {...props} data={data} />;
}
